module.exports = __webpack_public_path__ + "static/images/5e2fcf3fa040b17e3137d4368cda235d.png";